import { styled } from 'goober'

export const CardsList = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 0.5em;
  flex-wrap: wrap;
  align-items: flex-start;
`
